
<!-- handles if Certificate async fetch hasn't been received yet-->
<loading :loading="!Boolean(handler.certificate)">
  <template #loading>
    <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
    >
      <template #section-header>
        <xpinner/>
      </template>
    </collapsible-section>
  </template>

  <template #loaded>
    <collapsible-section
        class="collapse-item"
        :is-open="false"
        :id="`certificateDynamicInputsCollapse-${certificate.client_id}-${dropdownControlId}`"
        control-name="certificateDynamicInputsCollapse"
    >
      <template #section-header>
        <row>
          <prefix>
            <icon :glyph="varIOClass(handler.variable)"/>
          </prefix>
          <column>
            {{ handler.rootHeader }}
          </column>
        </row>
      </template>

      <template #section-contents>
        <collapsible-section
            class="collapse-item"
            :id="`certificateDynamicInputsPropertiesCollapse-${certificate.id}-${dropdownControlId}`"
            control-name="certificateDynamicInputsPropertiesCollapse"
            :is-open="true"
        >
          <template #section-header>
            Properties
          </template>

          <template #section-contents>
            <dynamic-input-section-data
                :handler="handler"
                :q="q"
                :section="dynamicInputsSection"
                :parent-tree-context="computedChildTreeContext"
                @select="select"
            ></dynamic-input-section-data>
          </template>
        </collapsible-section>
      </template>
    </collapsible-section>
  </template>
</loading>
